// extracted by mini-css-extract-plugin
export var actionButton = "_rg-0";
export var actionMenuContainer = "_rg-i";
export var bubble = "_rg-2";
export var bubbleActionMenu = "_rg-j";
export var bubbleContext = "_rg-6";
export var bubbleItems = "_rg-7";
export var customer = "_rg-3";
export var divider = "_rg-8";
export var fileList = "_rg-9";
export var hiddenComment = "_rg-o";
export var infoAbove = "_rg-a";
export var internal = "_rg-4";
export var lightActionButton = "_rg-1";
export var link = "_rg-b";
export var merchant = "_rg-5";
export var message = "_rg-c";
export var profilePicture = "_rg-e";
export var quillToolbarContainer = "_rg-f";
export var senderDate = "_rg-g";
export var senderDateCustomer = "_rg-h";
export var senderName = "_rg-d";
export var time = "_rg-k";
export var uploadedImage = "_rg-l";
export var username = "_rg-m";
export var xsmall = "_rg-n";